export default "__VITE_ASSET__D63rqhVk__"